import { Box, Container, Stack } from "@mui/material";
import { Logo } from "./logo";
import { Menu } from "./menu";
import { StickyHeader } from "./sticky-header";
import React from "react";
export const DesktopNavigation = ({ logo, menuItems = [], stickyLogo, }) => (React.createElement(React.Fragment, null,
    React.createElement(Box, { component: "header", role: "menubar", sx: {
            backgroundColor: "transparent",
            left: 0,
            pb: 0,
            position: "absolute",
            pt: { md: 4, xl: 8 },
            top: 0,
            width: "100%",
            zIndex: 30,
        } },
        React.createElement(Container, { "data-testid": "desktop-navigation-container" },
            React.createElement(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between" },
                React.createElement(Box, { sx: { flexGrow: 1 } },
                    React.createElement(Logo, { logo: logo })),
                React.createElement(Menu, { menuItems: menuItems })))),
    React.createElement(StickyHeader, { logo: stickyLogo, menuItems: menuItems })));
//# sourceMappingURL=desktop-navigation.js.map